import * as React from 'react';
import { Operations, Hooks } from '@grandvisionhq/carts-v2';
import { useMutation } from '@grandvisionhq/graphql';
import { getPaymentImplementation } from '@grandvisionhq/payments';
import { isNil } from '@grandvisionhq/utils';
import '@swc/helpers';
import { getRestPaymentMethodName } from '../../StepPayment/utils/get-payment-method-name.js';
import '@grandvisionhq/api-client';

const findAdditionalCostForPayment = (additionalCosts, paymentMethod)=>{
    return additionalCosts.find((p)=>p.key === paymentMethod
    );
};
const useAddAdditionalCosts = ()=>{
    var ref;
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(Operations.Mutations.REMOVE_CART_LINE_ITEMS);
    const { data  } = Hooks.useGetCart();
    const [addToCart, addToCartMutation] = Hooks.useAddToCart();
    const currentAdditionalCostsForPaymentLineItem = data === null || data === void 0 ? void 0 : (ref = data.additionalCartCostLineItems) === null || ref === void 0 ? void 0 : ref[0];
    const removeFromCart = React.useCallback((lineItemId)=>{
        if (!data || isNil(data)) {
            console.error('No cart ID available');
            return;
        }
        const cartId = data.id;
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItemId
                        }, 
                    ]
                }
            }
        });
    }, [
        data,
        removeCartItems
    ]);
    const addAdditionalPaymentCostsIfApplicable = React.useCallback((selectedPaymentMethod, additionalCosts, selectedAdditionalCartCosts)=>{
        const selectedPaymentImplementation = selectedPaymentMethod && getPaymentImplementation(selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.provider, selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type);
        let finalAdditionalCartCosts;
        if (!selectedAdditionalCartCosts) {
            finalAdditionalCartCosts = additionalCosts && selectedPaymentImplementation && findAdditionalCostForPayment(additionalCosts, getRestPaymentMethodName(selectedPaymentImplementation.type));
        } else {
            finalAdditionalCartCosts = selectedAdditionalCartCosts;
        }
        const isReelectingAdditionalCosts = finalAdditionalCartCosts && currentAdditionalCostsForPaymentLineItem;
        let applicable = true;
        if (!selectedPaymentMethod || !selectedPaymentImplementation || isReelectingAdditionalCosts || !additionalCosts || !(additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts.length)) {
            applicable = false;
        }
        if (!applicable) {
            return;
        }
        if (finalAdditionalCartCosts && !currentAdditionalCostsForPaymentLineItem) {
            addToCart([
                {
                    sku: finalAdditionalCartCosts.masterVariant.sku || '',
                    quantity: 1,
                    type: 'regular'
                }, 
            ]);
        }
        if (currentAdditionalCostsForPaymentLineItem) {
            removeFromCart(currentAdditionalCostsForPaymentLineItem.id);
        }
    }, [
        currentAdditionalCostsForPaymentLineItem,
        addToCart,
        removeFromCart
    ]);
    return {
        addAdditionalPaymentCostsIfApplicable,
        error: {
            addAdditionalCartCostError: addToCartMutation === null || addToCartMutation === void 0 ? void 0 : addToCartMutation.error,
            removeAdditionalCartCostError: removeCartLineItemsMutation === null || removeCartLineItemsMutation === void 0 ? void 0 : removeCartLineItemsMutation.error
        }
    };
};

export { findAdditionalCostForPayment, useAddAdditionalCosts };
//# sourceMappingURL=use-add-additional-costs.js.map
